import { ref } from 'vue';

const horizontalFacetsRef = ref(null);
export default function useHorizontalFacetsRef() {
  return horizontalFacetsRef;
}
